<template>
  <footer class="footer">
    <p>&copy; 2025 Brave Bites. All rights reserved.
      <router-link to="/disclaimer" class="button link disclaimer-link">Disclaimer</router-link>
    </p>
    <p>Alpha Version 1.0</p>
  </footer>
</template>

<style scoped>
.footer {
  margin-top: var(--space-lg);
  height: 70px;
  width: 100%;
  background-color: hsl(30, 32%, 95%);
  padding-top: 10px;
  text-align: center;
  font-size: 0.8rem;
  color: hsl(88, 21%, 40%);
}

.footer a {
  font-size: .8rem;
}

.footer p {
  margin: 5px 0;
}

.disclaimer-link {
  padding: 0;
}
</style>
